export default {
  // General TR5
  'tr5.odometer': 'Odometer',
  'tr5.year': 'Year',
  'tr5.nav.menu.editProfile': 'Edit profile',
  'tr5.nav.menu.accounting': 'Accounting',
  'tr5.nav.menu.reports': 'Reports',
  'tr5.nav.menu.settings': 'Settings',
  'tr5.nav.menu.chat': 'Chat with us',
  'tr5.nav.menu.support': 'Support',
  'tr5.nav.menu.logout': 'Logout',
  'tr5.nav.menu.switchUser': 'Switch User',
  'tr5.poweredBy': 'Powered by',
  'tr5.trademark':
    '© {year} TradeRev® is a trademark of NthGen Software®. All rights reserved.',
  'tr5.select': 'Select',
  'tr5.na': 'N/A',

  'tr5.controls.more': 'More',
  'tr5.controls.sendToClosing': 'Send to Closing Auction',
  'tr5.controls.parkVehicle': 'Park vehicle',
  'tr5.controls.editVehicle': 'Edit vehicle',
  'tr5.controls.auctionInDGN': 'Auction in dealer group',
  'tr5.controls.sendToLost': 'Send to Lost',

  // General VDP
  'vdp.asis': 'As-is',
  'vdp.highbid': 'High bid!',
  'vdp.outbid': 'Outbid',
  'vdp.floorMet': 'Floor met',
  'vdp.floorPrice': 'Floor Price',
  'vdp.hasFloorPrice': 'Floor set',
  'vdp.closeToFloorPrice': 'Near floor!',
  'vdp.auctionEnded': 'Auction ended',
  'vdp.pendingEnded': 'Ended',
  'vdp.closingEnded': 'Closing Ended',
  'vdp.headerViews': '114 Views',
  'vdp.rateInfo': 'Rate info',
  'vdp.transportPromoOn': 'Promo on now!',
  'vdp.transportPromoInfoLong': 'Promotional rate info',
  'vdp.transportValueEstimated': 'estimated',
  'vdp.seller.detailsShownToBuyer': 'Details shown to buyer',

  // Pending Closing VDP
  'vdp.closing.buyer.disclaimer':
    'By placing a bid you verify that you have reviewed the vehicle details page and the vehicle history report.',
  'vdp.pending.buyer.button.reply': 'Reply',
  'vdp.pending.buyer.button.startNegotiation': 'Start negotiation',
  'vdp.pending.buyer.button.view': 'View negotiation',
  'vdp.pending.buyer.declined': 'Declined',
  'vdp.pending.buyer.label.buyerCounter': 'Your counter',
  'vdp.pending.buyer.label.buyerFirm': 'Firm at',
  'vdp.pending.buyer.label.buyerOffer': 'Your offer',
  'vdp.pending.buyer.label.finalAskingPrice': 'Final asking price',
  'vdp.pending.buyer.label.newAsking': 'New asking price',
  'vdp.pending.buyer.label.nowInActive': 'Now in Active Auction',
  'vdp.pending.buyer.label.nowInUpcoming': 'Now in Upcoming',
  'vdp.pending.buyer.label.sellerCounter': 'New counter',
  'vdp.pending.buyer.label.sellerOffer': 'New asking price',
  'vdp.pending.buyer.label.sentToSecondBidder': 'Sent to 2nd bidder',
  'vdp.pending.buyer.label.yourOffer': 'Your offer',
  'vdp.pending.buyer.label.yourTopBid': 'Your top bid',
  'vdp.pending.seller.button.reply': 'Reply',
  'vdp.pending.seller.button.sendToClosing': 'Send to Closing Auction',
  'vdp.pending.seller.button.startNegotiation': 'Start negotiation',
  'vdp.pending.seller.button.viewNegotiation': 'View',
  'vdp.pending.seller.label.buyerCounter': 'New counter',
  'vdp.pending.seller.label.buyerFirm': 'Buyer firm at',
  'vdp.pending.seller.label.buyerOffer': 'New offer',
  'vdp.pending.seller.label.new': 'New',
  'vdp.pending.seller.label.finalAskingPrice': 'Your final asking price',
  'vdp.pending.seller.label.sellerCounter': "You're asking for",
  'vdp.pending.seller.label.sellerOffer': "You're asking for",
  'vdp.pending.tiah.invitedCustomer': 'Invited Customer',
  'vdp.pending.tiah.createdAt.dateExists.invitedCustomer':
    'You sent your customer an invite to Trade-In at Home and they parked their trade on ',
  'vdp.pending.tiah.createdAt.emptyDate.invitedCustomer':
    'You sent your customer an invite to Trade-In at Home and they parked their trade.',

  // Confirmation Modals
  'vdp.confirmation.title.sameDealership':
    'Someone else at your dealership is currently the top bidder on this vehicle.',
  'vdp.confirmation.title.sameDealershipMessage':
    'Bidders from the same dealership will not go to Closing together. Do you still want to submit your bid?',
  'vdp.confirmation.title.sameDealerGroup':
    'Another user in your dealer group is top bidder.',
  'vdp.confirmation.msg.submitBid': 'Do you still want to submit your bid?',
  'vdp.confirmation.title.bidSeemsHigh':
    'Your bid of {bidAmount} seems like it might be high.',
  'vdp.confirmation.title.startingBidSeemsHigh':
    'Your starting bid of {bidAmount} seems like it might be high.',
  'vdp.confirmation.msg.confirmBidAmount':
    'Did you mean to enter a starting bid of {bidAmount}? If so you can continue below.',
  'vdp.confirmation.title.proxySeemsHigh':
    'Your proxy bid of {proxyAmount} seems like it might be high.',
  'vdp.confirmation.msg.confirmProxyAmount':
    'Did you mean to enter a proxy amount of {proxyAmount}? If so you can continue below.',
  'vdp.confirmation.yesBid': 'Yes, Bid',

  // Toaster
  'toaster.dismiss.message': 'Dismiss',

  // Toaster Error Messages
  'vdp.error.startingBidLow':
    'The starting bid you entered was too low. Enter a starting bid of at least {minBidAmount}',
  'vdp.error.bidTooLow':
    'Your bid was too low. Enter a bid higher than the current one.',
  'vdp.error.startingBidLargerThanProxy':
    'Your starting bid is higher than your proxy amount. Enter a starting bid amount lower than your proxy amount.',
  'vdp.error.wrongBidIncrement':
    'Your bid was in the wrong increment. This vehicle requires bids in increments of {quickBidIncrement}',
  'vdp.error.noStartingBid': 'Please enter a starting bid amount.',
  'vdp.error.noBid': 'Please enter a bid amount.',
  'vdp.error.noProxy': 'Please enter a proxy amount.',
  'vdp.error.noProxyNoStartingBid':
    'You did not enter a proxy amount. Please enter both a starting bid and a proxy amount to set your proxy.',
  'vdp.error.proxyTooLow':
    'The proxy you entered was too low. Enter a proxy of at least {minProxyAmount}',
  'vdp.error.wrongProxyIncrement':
    'Your proxy bid was in the wrong increment. This vehicle requires bids in increments of {proxyIncrement}',
  'vdp.error.placingBid': 'There was a problem placing the bid.',
  'vdp.error.placingProxy': 'There was a problem placing a proxy on the trade.',
  'vdp.error.general':
    'There was a problem retrieving all the data on this trade, please wait or try refreshing the page',
  'bidding.error.unauthorized': 'Sorry, you are not authorized to bid.',
  'bidding.error.invalidAmount':
    'Your bid was in an invalid increment. Please enter bids below $1000 in increments of $50, or above $1000 in increments of $100.',
  'bidding.error.someoneElseBid':
    'Another person bid that amount just before you did. Please bid again.',

  // Toaster Success Messages
  'vdp.success.bidPlaced': 'Your bid has been successfully placed.',
  'vdp.success.proxySet':
    'Your proxy of {proxyAmount} has been set. You can edit it if you wish.',
  'vdp.success.vinCopied': 'VIN copied to clipboard',

  // VDP Header
  'vdp.launchTime.active.today': 'Launched today at {time}',
  'vdp.launchTime.yesterday': 'Launched yesterday at {time}',
  'vdp.launchTime.upcoming.today': 'Launching today at {time}',
  'vdp.launchTime.upcoming.today.sale': 'Today at {time}',
  'vdp.launchTime.tomorrow': 'Launching tomorrow at {time}',
  'vdp.launchTime.tomorrow.sale': 'Tomorrow at {time}',
  'vdp.launchTime.future': 'Launching {date} at {time}',
  'vdp.launchTime.future.sale': '{date} at {time}',
  'vdp.launchTime.past': 'Launched on {date} at {time}',
  'vdp.expirationTime.pending.today': 'Pending ends today at {time}',
  'vdp.expirationTime.pending.tomorrow': 'Pending ends tomorrow at {time}',
  'vdp.expirationTime.pending.future': 'Pending ends {date} at {time}',
  'vdp.watch': 'Watch',
  'vdp.watched': 'Watched',
  'vdp.close': 'Close',
  'vdp.share': 'Share vehicle',

  // VDP Overview
  'vdp.overview.vin': 'VIN',
  'vdp.overview.copyVin': 'Copy VIN:',
  'vdp.overview.transmissionDriveTrain': 'Powertrain',
  'vdp.overview.dateExpected': 'Date expected',
  'vdp.overview.specsFeatures': 'Full specs & features',
  'vdp.overview.make': 'Make',
  'vdp.overview.model': 'Model',
  'vdp.overview.trim': 'Trim',
  'vdp.overview.color': 'Exterior/Interior colour',
  'vdp.overview.seats': 'Seats',
  'vdp.overview.vehicleFeatures': 'Vehicle features',
  'vdp.overview.viewAll': 'View full list',
  'vdp.overview.media.overview': 'Overview',
  'vdp.overview.media.disclosure': ' Disclosure',
  'vdp.overview.media.videos': 'Videos',
  'vdp.overview.media.open': 'Open multimedia',
  'vdp.overview.tradeId': 'Trade ID',
  'vdp.overview.rateInfo.noQuote': 'No quote available',
  'vdp.overview.rateInfo.promoRateInfo': 'Promotional transport rate info',
  'vdp.overview.rateInfo.rateInfo': 'Transport rate info',

  // VDP Multimedia
  'vdp.multimedia.title': 'Multimedia',
  'vdp.multimedia.disclosureImages': 'Disclosure images',
  'vdp.multimedia.overviewImages': 'Overview images',
  'vdp.multimedia.video': 'Video',
  'vdp.multimedia.header.esc': 'Press the <esc>esc</esc> key to',
  'vdp.multimedia.interiordamage': 'Interior Damage',
  'vdp.multimedia.exteriordamage': 'Exterior Damage',
  'vdp.multimedia.other': 'Other',

  // VDP Bid
  'vdp.bid.tradeState.active': 'Active',
  'vdp.bid.tradeState.upcoming': 'Upcoming',
  'vdp.bid.tradeState.pending': 'Pending',
  'vdp.bid.tradeState.closing': 'Closing',
  'vdp.bid.tradeState.arrived': 'Arrived',
  'vdp.bid.tradeState.delivered': 'Delivered',
  'vdp.bid.proxyAmount': 'Proxy amount',
  'vdp.bid.startingBid': 'Starting Bid',
  'vdp.bid.auctionLaunched': 'Auction launched',
  'vdp.bid.bidAmount': 'Bid amount',
  'vdp.bid.currentBidAmount': 'Current bid amount',
  'vdp.bid.beFirst': 'Be the first to bid!',
  'vdp.bid.noBids': 'No bids yet',
  'vdp.bid.timeLeft.countdown.seconds': '{seconds}s',
  'vdp.bid.timeExtended': 'Extended',
  'vdp.bid.under30s': 'Under 30s',
  'vdp.bid.left': 'left',
  'vdp.bid.timeLeft': '{time}{unit} left',
  'vdp.bid.timeLeft.countdown': '{minutes}min {seconds}s',
  'vdp.bid.timeLeft.countdown.minutes': '{minutes}min',
  'vdp.bid.under1Min': 'Under 1 min',
  'vdp.bid.pendingVHR': 'The history report for this vehicle is still pending.',
  'vdp.bid.floorPrice': 'Floor: {floorPrice}',
  'vdp.bid.fullHistory': 'Full history',
  'vdp.bid.fullBidHistory': 'Full bid history',
  'vdp.bid.numberOfBids': '{numberOfBids, plural, one {# bid} other {# bids}}',
  'vdp.bid.yourBid': 'Your bid',
  'vdp.bid.placedDaysAgo':
    '{daysAgo, plural, one {# day ago} other {# days ago}}',
  'vdp.bid.placedHoursAgo':
    '{hoursAgo, plural, one {# hour ago} other {# hours ago}}',
  'vdp.bid.placedMinutesAgo':
    '{minsAgo, plural, one {# min ago} other {# mins ago}}',
  'vdp.bid.button.bid': 'Bid',
  'vdp.bid.button.placeBid': 'Place a bid',
  'vdp.bid.button.setProxy': 'Set proxy',
  'vdp.bid.currentBid': 'Current bid',
  'vdp.bid.button.setProxyAmount': 'Set {proxyAmount} proxy',
  'vdp.bid.button.editProxy': 'Edit proxy',
  'vdp.bid.button.setProxyAndBidAmount':
    'Bid {bidAmount} & set {proxyAmount} proxy',
  'vdp.bid.button.editProxyAmount': 'Edit {proxyAmount} proxy',
  'vdp.bid.button.quick.min.bid': 'Min bid',
  'vdp.bid.proxyMessage':
    'Proxy bidding: We’ll bid just enough to keep you top bidder, up to your proxy amount.',
  'vdp.bidModal.form.setProxy': 'Set a proxy Amount',
  'vdp.bidOverview.form.setProxy': 'Set proxy',
  'vdp.bid.editBidAmount': 'Edit',
  'vdp.bid.selectDealership.prefix': 'Bidding as:',
  'vdp.bid.selectDealership.invalidDealership': 'Pick a dealership to continue',
  'vdp.bid.default': '(Default)',
  'vdp.bid.switchDealerships':
    'Changing the dealership you’re bidding as may change transport estimates. Please confirm the estimated cost before bidding.',

  // VDP Inner Nav
  'vdp.innerNav.overview': 'Overview',
  'vdp.innerNav.condition': 'Condition',
  'vdp.innerNav.history': 'History',
  'vdp.innerNav.transportSeller': 'Transport & Seller',
  'vdp.innerNav.research': 'Research',

  // VDP Conditions Disclosures
  'vdp.conditions.title': 'Condition',
  'vdp.conditions.thirdPartyInspected': 'Third Party Inspected',
  'vdp.conditions.seeChecklist': 'See checklist',
  'vdp.conditions.nothingReported': 'Nothing reported',
  'vdp.conditions.inspectionDealerNotes': 'Inspection & dealer notes',
  'vdp.conditions.alwaysReadNotes':
    'Always read & review all notes before bidding.',
  'vdp.conditions.noNotes': 'No notes provided',

  // VDP History
  'vdp.history.title': 'History summary',
  'vdp.history.alwaysViewReport':
    'Always view the {reportType} report before bidding.',
  'vdp.history.waitingVHR': 'Waiting for vehicle history report.',
  'vdp.history.viewButton': 'View',
  'vdp.history.noneReported': 'None reported',

  // VDP Transport details
  'vdp.transport.Details': 'Transport details',
  'vdp.transport.Disclosures': 'Transport disclosures',
  'vdp.transport.NothingReported': 'Nothing reported',
  'vdp.transport.NotAvailable': 'Not available',
  'vdp.transport.NotDriveable': 'Not eligible for driveaway{delimeter}',
  'vdp.transport.NotDriveableDiscTitle':
    'This vehicle cannot be moved under its own power.',
  'vdp.transport.IsOversized': 'Is oversized',
  'vdp.transport.DateExp': 'Date expected',
  'vdp.transport.Estimate': 'Transport estimate',
  'vdp.transport.PromoOn': 'Promo on now!',
  'vdp.transport.PromoInfo': 'Promo info',
  'vdp.transport.VehicleLocation': 'Vehicle location',
  'vdp.transport.estimateNotAvailable':
    'Transport estimate not available for this vehicle right now',
  'vdp.transport.estimate': 'Transport from {city}, {province} to you: ',
  'vdp.transport.hasDateExpectedExceededLimit':
    'Date expected is more than {dateExpectedDaysLimit} days from launch',
  'vdp.transport.estimateWithStreet':
    'to {street}, {city}, {province}, {postalCode}',

  // VDP Seller Info
  'vdp.seller.heading': 'Seller info',
  'vdp.seller.qa': 'Questions & answers',
  'vdp.seller.qaButton': 'Open Q&A',
  'vdp.seller.dealer': 'Selling dealer',
  'vdp.seller.answers':
    '{chatCount, plural, one {# question & answer} other {# questions & answers}}',
  'vdp.seller.ratings':
    '({ratingsCount, plural, one {# rating} other {# ratings}})',
  'vdp.seller.network': 'Network:',
  'vdp.seller.payments': 'Accepted payments',
  'vdp.seller.noRatings': '(No ratings yet)',

  // VDP Research
  'vdp.research.heading': 'Research',
  'vdp.research.subheading':
    'Last 90 days of TradeRev market data for similar vehicles',
  'vdp.research.average': 'Average Price',
  'vdp.research.highest': 'High',
  'vdp.research.lowest': 'Low',
  'vdp.research.researchVin': 'Open this VIN in TradeRev research',
  'vdp.research.autoniq': 'Lookup this vehicle in Autoniq',
  'vdp.research.autoniq.short': 'Lookup in Autoniq',
  'vdp.research.no.marketguide.data.part1':
    'Not enough wholesale market data for ',
  'vdp.research.no.marketguide.data.part2': 'this year, make, model and trim ',
  'vdp.research.no.marketguide.data.part3':
    'of this vehicle. Find similar vehicles by viewing in Market Guide and expanding the year range, or picking more trims.',

  // VDP Share Retail
  'vdp.retail.share': 'Share this vehicle with a customer',
  'vdp.retail.shareUrl': 'Share this vehicle URL',
  'vdp.retail.message':
    'Create a customer-friendly view of this page that you’re in control of to send to a potential customer.',
  'vdp.retail.link': 'Create Customer Link',
  'vdp.retail.noCarfax.title': 'CARFAX not ready yet',
  'vdp.retail.noCarfax.message':
    'You cannot create a customer link until the CARFAX has been added to this listing. Try again in a few minutes.',
  'vdp.retail.vhr': 'Vehicle history report',
  'vdp.retail.vhr.carfax':
    "See below for a link to this vehicle's CARFAX Canada report.",

  // VDP Footer
  'vdp.footer.findMore': 'Find more vehicles in {tradeState} auction.',
  'vdp.footer.backTo': 'BACK TO {tradeState}',

  // Mini VDP
  'mini.vdp.nothing.selected.heading': 'No vehicle selected.',
  'mini.vdp.nothing.selected.subheading':
    'Select a vehicle to the left to see details and bid.',

  // Retail VDP
  'retail.customization.heading': 'Share this vehicle with a customer',
  'retail.customization.subheading':
    'Create a customer friendly condition report that you can send to a potential customer. You are responsible for ensuring that all information regarding the vehicle and its condition is accurately conveyed to any prospective customer.',
  'retail.customization.form.title': 'Customize vehicle',
  'retail.customization.price': 'Customer price (optional)',
  'retail.customization.price.disclaimer': 'Not including tax & licensing',
  'retail.customization.media.vehicle.heading':
    'Vehicle photos (Minimum 1 photo)',
  'retail.customization.media.select': 'Select all',
  'retail.customization.media.deselect': 'Deselect all',
  'retail.customization.media.damage.heading': 'Include damage photos',
  'retail.customization.media.video.heading':
    'Include videos with audio (Please review videos to ensure content is appropriate for your customer)',
  'retail.customization.description.heading':
    'Customer friendly description of the vehicle to the listing (Optional)',
  'retail.customization.dealerDetails.heading': 'Dealership details (optional)',
  'retail.customization.dealerDetails.name': "Salesperson's name",
  'retail.customization.dealerDetails.email': "Salesperson's email",
  'retail.customization.dealerDetails.phone': "Salesperson's phone",
  'retail.customization.dealerDetails.inventory':
    "Link to dealership's used inventory",
  'retail.customization.dealerDetails.name.placeholder': 'Name',
  'retail.customization.dealerDetails.email.placeholder': 'example@email.com',
  'retail.customization.dealerDetails.phoneNumber.placeholder': '123-456-7890',
  'retail.customization.dealerDetails.inventory.placeholder':
    'Dealership website url',
  'retail.customization.create.description':
    'Creating the page will open a new tab in your browser. If you want to make a correction or make more then one page, come back here and create another.',
  'retail.customization.create.button': 'Create page',
  'retail.create.loading.heading': 'We are creating your page...',
  'retail.create.loading.sub.heading': 'This should only take a minute.',
  'retail.create.loading.cancel': 'CANCEL',
  'retail.customization.input.error':
    'Please correct all of the errors on the page before you can continue',
  'retail.customization.image.input.error':
    'You need to have at least one vehicle image selected to create a customer friendly vehicle details page',
  'retail.customization.footer':
    'Please note that the dealership is responsible for complying with all applicable provincial laws relating to the retail sale of motor vehicles, including any disclosure obligations.',
  'retail.city': 'City',
  'retail.highway': 'Highway',
  'retail.features': 'Features',
  'retail.description': 'Description',
  'retail.directions.link': 'Directions',
  'retail.salesperson.label': 'Sales person',
  'retail.seeMore.title': 'Not interested in this vehicle?',
  'retail.seeMore.button': 'See more inventory',
  'retail.tiah.title': 'Do you have a trade-in?',
  'retail.tiah.text':
    'Send <name>{dealership}</name> your vehicle information and we’ll let hundreds of dealers bids on it, so you can get a fair price from the comfort of your home.',
  'retail.tiah.button': 'Start capturing your vehicle',
  'retail.url.copied': 'Link has been copied to clipboard',
  'retail.footer':
    'Nth Gen Software Inc., operating as OPENLANE, is not responsible for the accuracy of the condition or options available on the vehicle displayed above. OPENLANE is a wholesale marketplace and only registered motor vehicle dealers may purchase vehicles from OPENLANE. Accordingly, OPENLANE shall not be construed as having entered into any contract with you or any consumer and is not responsible for any representations, warranties or communications made by any registered motor vehicle dealer to you or any consumer. Please note that the dealership is responsible for complying with all applicable provincial laws relating to the retail sale of motor vehicles, including any disclosure obligations. Please contact your dealer for all details.',
  'retail.error': 'This page no longer exists',
  'retail.tiah.learn.more.text':
    'Let them know it’s from you by adding your Dealership branding to this.',
  'retail.tiah.learn.more': 'Learn more',

  // Nav Search Bar
  'list.nav.searchbar.placeholder': 'Search',
  'list.nav.searchbar.modal.searchbar.title': 'Search in ',
  'list.nav.searchbar.modal.searchbar.title.omp.sell': 'Search in Selling',
  'list.nav.searchbar.modal.search.selling': 'Selling',
  'list.nav.searchbar.modal.search.buying': 'Buying',
  'list.nav.searchbar.modal.searchbar.placeholder':
    'Search by year, make, model, trim, color, full or partial VIN or trade ID',
  'list.nav.searchbar.modal.searchbar.placeholder.omp.sell':
    'Search for a vehicle in Selling',
  'list.nav.searchbar.modal.searchButton': 'Search',
  'list.nav.searchbar.modal.closeButton': 'Close',
  'list.nav.searchbar.modal.hint.sKey':
    'You can press the <sKey>S</sKey> key to open search, ',
  'list.nav.searchbar.modal.hint.escKey':
    'and the <escKey>esc</escKey> key to close it.',
  'list.nav.searchbar.modal.search.history': 'Your recent searches',
  'list.nav.searchbar.modal.search.results':
    '{resultsMatching, plural, =0 {0 {state} results} one {# {state} result} other {# {state} results}} matching ’{inputString}’ in {context}',
  'list.nav.searchbar.modal.search.end': 'End of matching results',
  'list.nav.searchbar.modal.similar.trades':
    'Similar trades you maybe interested in:',
  'list.nav.search.no.results':
    'Hmm... we didn’t find any matching results in {state}.',
  'list.nav.search.no.results.try':
    'Try a search using year, make, model, trim, colour, full or partial VIN, or vehicle ID.',
  'list.currently.in': 'Currently in ',
  'list.results.total': 'total',
  'list.nav.searchbar.modal.search.results.loading':
    'Loading results matching ’{inputString}’ in {context}',

  // List card
  'list.launchTime.active.today': 'Launched to Active today at {time}',
  'list.launchTime.upcoming.today': 'Active today at {time}',
  'list.launchTime.tomorrow': 'Active tomorrow at {time}',
  'list.launchTime.future': 'Active {date} at {time}',
  'list.launchTime.past': 'Launched to Active on {date} at {time}',

  // Layout
  'layout.list': 'List',
  'layout.grid': 'Grid',

  // Sorting
  'list.sorting.label': 'Sorted',
  'list.sorting.endingSoonest': 'Ending soonest',
  'list.sorting.activeSoonest': 'Active soonest',
  'list.sorting.recentlyListed': 'Recently listed',
  'list.sorting.mileageLowHigh': 'Mileage: low to high',
  'list.sorting.mileageHighLow': 'Mileage: high to low',
  'list.sorting.yearNewOld': 'Year: new to old',
  'list.sorting.yearOldNew': 'Year: old to new',

  // Filters
  'list.filters.headertext': 'Filters',
  'list.filters.clear': 'CLEAR',
  'list.filters.mysavedfilters': 'My saved filters',
  'list.filters.save': 'SAVE',
  'list.filters.add.logo': 'Add logo',
  'list.filters.edit.details': 'Edit details',
  'list.filters.overwrite': 'OVERWRITE',
  'list.filters.from': 'from',
  'list.filters.away': '{distance} {unit} away',
  'list.filters.inStock': 'In-stock vehicles only',
  'list.filters.floorMet': 'Floor price met only',
  'list.filters.franchiseDealers': 'Franchise dealers only',
  'list.filters.year.before': 'Before {year}',
  'list.filters.allSelected': 'All selected',
  'list.filters.numberSelected': '{number} selected',
  'list.filters.apply': 'Apply',
  'list.filters.only': 'ONLY',
  'list.filters.makes': 'Makes',
  'list.filters.models': 'Models',
  'list.filters.allMakes': 'All makes selected',
  'list.filters.allModels': 'All models selected',
  'list.filters.allFuelTypes': 'All fuel types selected',
  'list.filters.searchMakes': 'Search makes',
  'list.filters.searchModels': 'Search models',
  'list.filters.transmission': 'Transmission',
  'list.filters.fuelType': 'Fuel type',
  'list.filters.province': `{provinceCount, plural, one {Province} other {Provinces}}`,
  'list.filters.distance': 'Distance',
  'list.filters.distance.any': 'Any distance away',
  'list.filters.conditions.asIs': 'Hide As-is vehicles',
  'list.filters.conditions.any.history':
    'Hide vehicles with any accident history',
  'list.filters.conditions.accident.amount':
    'Hide vehicles with accidents over $3000',
  'list.filters.isEditing': '(editing)',
  'list.filters.notification.label': 'Get Notifications for this saved filter',
  'list.filters.notification.success':
    'We’ll notify you when vehicles matching this saved filter are available.',
  'list.filters.notification.error':
    'Something went wrong turning on this filter notification. Please try again.',
  'list.filters.networks.all': 'All networks',
  'list.filters.save.confirmation.title': 'Create a new saved filter.',
  'list.filters.apply.confirmation.title': 'Overwrite your saved filter?',
  'list.filters.apply.body.message':
    'This will update ’{name}’ with your currently selected set of filters.',
  'list.filters.save.success': 'Successfully created a new saved filter',
  'list.filters.save.error': 'Something went wrong creating this saved filter',
  'list.filters.save.confirmation.msg':
    'We’ll save your currently selected filters so you can access them quickly again when you need.',
  'list.filters.save.confirmation.newName':
    'New saved filter name (max 25 chars)',
  'list.filters.save.confirmation.placeholder': 'Choose a distinct name',
  'list.filters.save.custom.title': 'Filter notifications are disabled',
  'list.filters.save.custom.msg':
    'Would you like to be notified of vehicles matching saved filters? If you say yes we’ll enable your filter notifications.',
  'list.filters.save.notificationsOff.title': 'All notifications are disabled',
  'list.filters.save.notificationsOff.msg':
    'If you’d like to be notified of vehicles matching your saved filters, please go to Settings > Notifications and pick your notification preset.',
  'list.filters.updateNotification.success': 'Notification settings updated',
  'list.filters.updateNotification.error':
    'Something went wrong updating notification settings',
  'list.filters.save.noFilterName': 'Please enter a filter name',
  'list.filters.save.duplicateFilter':
    'A filter named {name} already exists, please pick a different name for your filter',
  'list.filters.provinces.all': 'All provinces selected',
  'list.filters.provinces.some': '{number} provinces selected',
  'list.filters.delete.header': 'Delete this saved filter?',
  'list.filters.delete.body':
    ' This will remove the filter ’{filterTitle}’ from your saved filters list.',
  'list.filters.delete.cancel': 'CANCEL',
  'list.filters.delete.delete': 'DELETE',

  // Filter pills
  'list.filters.pills.distance': '{number} km away',
  'list.filters.pills.mileageRange': '{range} km',

  // Refresh list button
  'list.button.refresh': 'Refresh List',
  'list.button.refresh.text.active': 'Several auctions have ended.',
  'list.button.refresh.text.upcoming':
    'Several auctions have launched to Active.',

  // List menu
  'list.options.impound': 'Impound this vehicle',
  'list.options.unimpound': 'Unimpound this vehicle',
  'list.options.removeVehicle': 'Remove this vehicle',
  'list.options.deleteVehicle': 'Delete this vehicle',
  'list.options.launchToActive': 'Launch this vehicle to Active',
  'list.options.impound.success':
    'Trade successfully added to your Impound List', // need translation
  'list.options.impound.error': 'Something went wrong impounding the trade', // need translation
  'list.options.unimpound.success':
    'Trade successfully removed from your Impound List', // need translation
  'list.options.unimpound.error': 'Something went wrong unimpounding the trade', // need translation

  // Modals
  'modal.yes': 'Yes',
  'modal.ok': 'Ok',
  'modal.noThanks': 'No thanks',
  'modal.cancel': 'Cancel',
  'modal.confirmation.loading': 'Loading...',
  'modal.confirmation.confirmYourBid.title':
    'Have you read the details page & history report for this vehicle?',
  'modal.confirmation.confirmYourBid.description':
    'We’ll only ask once for this vehicle – further bids will not prompt this message.',
  'modal.submit': 'Submit',

  // Badges
  'badges.volumeSellerBadge': 'Volume Seller',
  'badges.volumeSellerBadge.description': 'One of the highest volume sellers',
  'badges.hasDisclosures': 'Has disclosures',
  'badges.inStock': 'In stock',
  'badges.QA': 'Q&A',

  // Tooltips
  'tooltips.isFloorPriceMet':
    'Floor price has been met, this vehicle is guaranteed to sell.',
  'tooltips.hasFloorPrice':
    'If the seller’s floor price is met, this vehicle will be guaranteed to sell.',
  'tooltips.isCloseToFloorPrice':
    'Current bid is almost at the seller’s floor price - keep bidding!',

  // Pagination
  'pagination.prev': 'Prev',
  'pagination.next': 'Next',
  'pagination.title': 'Page {currentPage} of {totalPages}',

  // List Sale Event
  'list.saleEvent.end.of.event': 'END OF EVENT',
  'list.saleEvent.event.continued': 'EVENT CONTINUES ON NEXT PAGE...',
  'list.saleEvent.start.of.event': 'Jump to start of event',
  'list.saleEvent.dealer.event': 'DEALER EVENT',
  'list.saleEvent.dealer.event.continued': 'DEALER EVENT CONTINUED...',
  'list.saleEvent.vehicles': 'vehicles',
  'list.saleEvent.hosted.by': 'Hosted by',
  'list.saleEvent.network': 'Network',
  'list.saleEvent.active': 'Active',

  // List Header, Footer & Empty state
  'list.header.vehicles': 'vehicles total',
  'list.header.pending':
    'After their time in Active ends, vehicles will appear here if the floor price isn’t met.',
  'list.header.amount.vehicles': '{amount} vehicles',
  'list.header.buy.upcoming':
    'These vehicles will be available in auction soon. Preview vehicles and set proxy bids.',
  'list.header.buy.active': 'Bid on vehicles in our live auction.',
  'list.header.buy.pending.decision.heading':
    'Waiting on seller decision | {totalBid} bid total value',
  'list.header.sell.pending.decision.heading':
    'Need a decision | {totalBid} total high bid value',
  'list.header.buy.pending.decision.subheading':
    'The seller will decide to sell the vehicle or not.',
  'list.header.sell.pending.decision.subheading':
    'Close deals to sell the vehicle, or try negotiating with the top bidder.',
  'list.header.paymentsOnHold': 'Payments on hold',
  'list.header.paymentsOnHold.caption':
    'See vehicles with payments owing in both Arrived and Delivered.',
  'list.modal.pending.park.confirm.title': 'End auction and move to Parked',
  'list.modal.pending.openNetwork.park.confirm.title':
    'Park open network trade',
  'list.modal.pending.park.confirm.message':
    'This will end the auction and any opportunity to negotiate with the top two bidders.',
  'list.modal.dgn.park.error.title': 'Cannot park trade',
  'list.modal.dgn.park.error.message':
    'You cannot Park a dealer group network trade. If you want to relaunch or edit this trade you can Park the open network version of this trade.',
  'list.modal.edit.error.title': 'Cannot edit trade',
  'list.modal.edit.error.message':
    'You cannot edit an open network or dealer group network trade.',
  'list.modal.dgn.markLost.message':
    'This will end this dealer group network auction and any opportunity to negotiate on it. The open network version of this vehicle will still be available.',
  'list.modal.open.markLost.message':
    'This will end this open network auction and any opportunity to negotiate on it. The dealer group network version of this vehicle will still be in auction.',
  'list.modal.pending.moveToClosing.confirm.message':
    'You cannot send this vehicle to the Closing Auction since there is only 1 bidder. <b>Accept the final bid of $ {acv} and move this vehicle to Won?</b>',
  'list.modal.pending.openNetwork.park.confirm.message':
    'When you Park this trade the dealer group network version of this trade will be moved to Lost.',
  'list.modal.pending.park.confirm.confirm': 'PARK VEHICLE',
  'list.modal.pending.park.confirm.success':
    'Trade has been Parked successfully',
  'list.modal.pending.park.confirm.error':
    'Something went wrong parking the trade',
  'list.controls.selectNetwork': 'Select network',
  'list.modal.pending.auctionToDealerGroup.in.nego.title':
    'You cannot start a dealer group network auction',
  'list.modal.pending.auctionToDealerGroup.in.nego.message':
    'You have started a negotiation, so you cannot start a dealer group auction. ',
  'list.modal.pending.auctionToDealerGroup.title':
    'Send to dealer group network auction',
  'list.modal.pending.auctionToDealerGroup.message':
    'Send this vehicle to your dealer group network. When the auction is over, you can decide which auction to close.',
  'list.modal.pending.auctionToDealerGroup.selectNetwork.label':
    'Dealer group network (Required)',
  'list.modal.pending.auctionToDealerGroup.startingBidAmount.label':
    'Set the starting price (Required)',
  'list.modal.pending.auctionToDealerGroup.confirm.button': 'START AUCTION',
  'list.modal.pending.auctionToDealerGroup.confirm.success':
    'Vehicle sent to Active Auction in the {dealerNetwork}.',
  'list.modal.pending.auctionToDealerGroup.confirm.error':
    'Something went wrong auctioning the trade in your selected dealer group',
  'list.modal.pending.auctionToDealerGroup.confirm.startBid.error':
    'Sorry, your starting bid cannot exceed the top bid your Open Trade.',
  'list.modal.pending.moveToLost.confirm.title': 'End auction and move to Lost',
  'list.modal.pending.moveToLost.confirm.message':
    'This will end the auction and any opportunity to negotiate with the top two bidders.',
  'list.modal.pending.moveToLost.confirm.confirm': 'MOVE TO LOST',
  'list.modal.pending.moveToLost.confirm.success':
    'Vehicle has been sent to Lost.',
  'list.modal.pending.moveToLost.confirm.error':
    'Something went wrong marking the trade as lost',
  'list.header.sell.closing.subheading':
    'You’ve given the top two bidders a second chance to make a winning bid on these vehicles.',
  'list.header.buy.pending.negotiations.heading':
    'In negotiations | {totalBid} total negotiation value',
  'list.header.sell.pending.negotiations.heading':
    'In negotiations | {totalBid} total negotiated value',
  'list.header.buy.pending.negotiations.subheading':
    'Unsucessful negotiations will move the auction to Lost.',
  'list.header.buy.closing.subheading':
    'Bidding continues for the top two bidders. This is your chance to make the winning bid. ',
  'list.header.buy.closing.outbid.heading': 'Outbid | {totalBid} total value',
  'list.header.buy.closing.highbid.heading':
    'High bid | {totalBid} total value',
  'list.footer.buy.upcoming': 'End of vehicles in Upcoming',
  'list.footer.buy.upcoming.filtered':
    'End of {tradeCount} matching results in Upcoming',
  'list.footer.buy.active': 'End of vehicles in Active',
  'list.footer.buy.active.filtered':
    'End of {tradeCount} matching results in Active',
  'list.footer.buy.looking': 'Looking for more vehicles?',
  'list.footer.buy.looking.pending':
    'Looking for more vehicles? It could be in Closing or Arrived.',
  'list.footer.buy.looking.dmp.pending':
    'Looking for more vehicles? It could be in Closing or Purchases.',
  'list.footer.buy.pending': 'End of vehicles in Pending',
  'list.footer.buy.pending.filtered':
    'End of {tradeCount} matching results in Pending',
  'list.footer.buy.looking.closing':
    'Looking for more vehicles? It could be in Won or Arrived.',
  'list.footer.sell.looking.closing':
    'Looking for a vehicle? It could be in Arrived.',
  'list.footer.sell.looking.pending':
    'Looking for more vehicles? It could be in Closing or Arrived.',
  'list.footer.buy.closing': 'End of vehicles in Closing',
  'list.footer.buy.closing.filtered':
    'End of {tradeCount} matching results in Closing',
  'list.footer.see.in': 'See What’s in {tradeState}',
  'list.footer.see.in.filtered': 'CHECK FOR MATCHES IN {tradeState}',
  'list.footer.button.backToDashboard': 'Back to dashboard',
  'list.footer.label.paymentsOnHold': 'End of vehicles in Payments on hold',
  'list.empty.content': 'Try fewer or other filters to see more vehicles.',
  'list.empty.buy.pending.decision.header':
    'There are no vehicles waiting for seller decision.',
  'list.empty.sell.pending.decision.header':
    'There are no vehicles that need a decision.',
  'list.empty.pending.decision.content':
    'Vehicles that do not meet their floor price in the Active Auction will go to Pending.',
  'list.empty.pending.negotiations.header':
    'There are no vehicles being negotiated right now.',
  'list.empty.buy.pending.negotiations.content':
    'You can start a negotiation with the Seller in Pending: Waiting for seller decision.',
  'list.empty.sell.pending.negotiations.content':
    'You can start a negotiation with the top bidder in Pending: Need a decision.',
  'list.empty.closing.outbid.header':
    'There are no vehicles in Closing - outbid.',
  'list.empty.closing.outbid.content':
    'You can bid on more vehicles in the Active Auction.',
  'list.empty.closing.highbid.header':
    'There are no vehicles in Closing - high bid.',
  'list.empty.closing.highbid.content':
    'You can bid on more vehicles in the Active Auction.',
  'list.empty.sell.closing.outbid.header': 'There are no vehicles in Closing',
  'list.empty.sell.closing.outbid.content':
    'You can find more vehicles to bid on in Upcoming and the Active Auction.',
  'list.filter.results': 'results',
  'list.filter.matching': 'matching',
  'list.filter.matchingAll': 'matching your filters',
  'list.filter.clear': 'CLEAR YOUR FILTERS',
  'list.openTrade.dgn.negotiate.error.title': 'You cannot negotiate yet.',
  'list.openTrade.dgnActive.negotiate.error.message':
    'The Dealer group network version of this trade is still in the Active auction. You can only negotiate once both trades are in Pending.',
  'list.openTrade.dgn.negotiateFirst.error.message':
    'You must negotiate on the dealer group network trade first. If you do not want to negotiate, mark it Lost. When the dealer group network version of this trade is marked Lost you will be able to negotiate on this trade.',
  'list.openTrade.dgn.negotiate.error.message':
    'You are currently negotiating on the Dealer group network version of this vehicle. Decline that negotiation if you want to negoitiate on the open network trade.',

  // Grid
  'grid.selected': 'SELECTED',

  // Card
  'list.card.distance.over': 'Over {distance}',
  'list.card.distance.within': 'Within {distance}',
  'list.card.negotiation.proposals.buyer': 'Buyer',
  'list.card.negotiation.proposals.you': 'You',
  'list.card.negotiation.start': 'Negotiate',
  'list.card.negotiation.view': 'View',
  'list.card.negotiation.reply': 'Reply',
  'list.card.negotiation.sendClosing': 'SEND TO CLOSING AUCTION',
  'list.card.negotiation.yourTopBid': 'Your top bid',
  'list.card.negotiation.topBid': 'Top bid',

  // Card DGN
  'list.card.dgn.network': 'Network {networkName}',
  'list.card.dgn.pending.network': '{networkName} (Duplicate in Open network)',

  // TRD
  'trd.description': 'Transport direct',
  'trd.tooltip':
    'Seller has opted to exclusively use Transport Direct, see Rate info',
  'trd.tooltip.promo':
    'Seller has opted to exclusively use Transport Direct, see Promo info',

  // Notifications
  'notifications.alerts': 'Alerts',
  'notifications.alerts.none': 'Nothing in your alerts.',
  'notifications.alerts.error':
    'An error was encountered fetching the alerts, please try again.',
  'notifications.todos': 'To-do list',
  'notifications.todos.none': 'Nothing in your to-do list.',
  'notifications.todos.error':
    'An error was encountered fetching the to-do list, please try again.',

  // Dealer badges on Nav bar
  'dealerBades.nav.tooltip.1': 'You are a volume seller',

  // Shared Badges Tooltips
  'sharedBadges.tooltip.1': 'One of the highest volume sellers',

  // TIAH Landing Page
  'tiah.landing.header.heading': 'Get more for your trade-in with TradeRev.',
  'tiah.landing.header.subheading':
    'Hassle-free with no negotiations or commitment. Just sit back and watch as thousands of dealers instantly bid on your vehicle.',
  'tiah.landing.header.form.placeholder': 'Enter your city or postal code',
  'tiah.landing.header.form.findDealers': 'FIND TRUSTED DEALERS',
  'tiah.landing.purpose.heading': 'HOW DOES TRADEREV WORK?',
  'tiah.landing.purpose.subheading':
    'Our dealers compete to buy <i>your</i> trade-in, giving you more money to put toward your new vehicle.',
  'tiah.landing.purpose.content':
    'We began as a dealer-only auction for used vehicles. Now instead of getting only one offer for your trade-in, you can tap into the buying power of that same dealer network to get more money for your trade-in.',
  'tiah.landing.stepone.heading': 'STEP ONE',
  'tiah.landing.stepone.subheading':
    'Pick the dealer you want to buy your new vehicle from.',
  'tiah.landing.stepone.content':
    'TradeRev is partnered with most dealers across Canada. That means you’ll always find a dealer to trade in and buy from close to you.',
  'tiah.landing.steptwo.heading': 'STEP TWO',
  'tiah.landing.steptwo.subheading': 'Tell us about your trade-in.',
  'tiah.landing.steptwo.content':
    'We’ll send your details to the dealer you pick, and they’ll contact you to discuss both your new vehicle purchase and trade-in. You can then complete the rest from home and only step into the dealership if you choose to finalize the deal.',
  'tiah.landing.stepthree.heading': 'STEP THREE',
  'tiah.landing.stepthree.subheading': 'Let the offers roll in.',
  'tiah.landing.stepthree.content':
    'No more “Let me talk to my manager.” Sit back as your trade-in is auctioned to our dealers. They’ll compete to buy your trade-in, and you decide if you’re happy with the final offer ',
  'tiah.landing.stepthree.content.hyperlink': '(subject to service fee)',
  'tiah.landing.stepthree.content.parttwo':
    '. There’s no obligation to accept.',
  'tiah.landing.getStartedNow': 'GET STARTED NOW',
  'tiah.landing.benefits.overview.heading': 'TRADEREV VS. THE COMPETITION',
  'tiah.landing.benefits.overview.subheading':
    'It’s really not even a fair fight.',
  'tiah.landing.benefitOne.subheading': 'No more back & forth.',
  'tiah.landing.benefitOne.content':
    'Dealers partnered with TradeRev auction your trade-in to our Canada-wide network to maximize your vehicles’ value. You’ll receive a clear appraisal with no negotiation required.',
  'tiah.landing.benefitTwo.subheading': 'Save time & hassle.',
  'tiah.landing.benefitTwo.content':
    'Safety inspections, government paperwork, cleaning, posting your old vehicle online, answering calls and emails, and the worst – haggling with strangers. Skip it all with TradeRev.',
  'tiah.landing.benefitThree.subheading': 'Maximize tax savings.',
  'tiah.landing.benefitThree.content':
    'By trading in with a dealership, you’ll save on taxes which you can put towards your new vehicles purchase.',
  'tiah.landing.marketing.mainHeading': 'WHAT IS TRADEREV?',
  'tiah.landing.marketing.heading':
    'We revolutionized an entire industry. No biggie.',
  'tiah.landing.marketing.subheading':
    'Nearly a decade ago we leveled the playing field for dealers.',
  'tiah.landing.marketing.content':
    'We built an industry leading digital marketplace for delears to buy and sell vehicles online based on trust & choice. Fast-forward to today and dealers across Canada sell thousands of vehicles every week on TradeRev.',
  'tiah.landing.marketing.subtext': 'Now you can too – with no committment.',
  'tiah.landing.marketing.statOne': '5000+ dealers',
  'tiah.landing.marketing.statOne.content':
    'in our network want your trade-in vehicle.',
  'tiah.landing.marketing.statTwo': '$2 billion+ in vehicles sold',
  'tiah.landing.marketing.statTwo.content':
    '<i>every year</i> across Canada on TradeRev',
  'tiah.landing.FAQ.heading': 'COMMON QUESTIONS',
  'tiah.landing.FAQ.subheading': 'Yes, we’re really just <i>that</i> good.',
  'tiah.landing.FAQ.one.question': 'Who’s actually buying my trade-in?',
  'tiah.landing.FAQ.one.answer':
    'Car dealers. When you launch your trade-in to our digital auction, our 5,000+ network of buying dealers have the ability to place bids and buy your vehicle.',
  'tiah.landing.FAQ.two.question': 'What if my trade-in is less than perfect?',
  'tiah.landing.FAQ.two.answer':
    'No car is perfect! That’s ok. You’ll have a chance to show photos of any wear or damage on your trade-in. Dealers are industry professionals who know that a trade-in comes with some imperfections.',
  'tiah.landing.FAQ.three.question': 'What if my trade-in was in an accident? ',
  'tiah.landing.FAQ.three.answer':
    'That’s ok! Dealers are used to buying and selling vehicles with some accident history. It’s totally normal. Our system will check your vehicle’s history from a variety of sources and tell our buyers about any accident history automatically.',
  'tiah.landing.FAQ.four.question':
    'My trade-in is leased or financed – can I still use TradeRev?',
  'tiah.landing.FAQ.four.answer':
    'Yes! Unlike selling to a private buyer, dealers are used to dealing with leasing and financing companies and can take care of the paperwork for you. This is a great reason to trade-in with TradeRev!',
  'tiah.landing.FAQ.five.question':
    'Does it cost money to use Trade-in at home?',
  'tiah.landing.FAQ.five.answer':
    'After your trade-in auction ends, if you choose to take the offer and sell your vehicle, a service fee will be deducted from the value of your trade-in by the dealership. The fee varies based on the final trade in value and will be displayed in the email sent to you when your auction ends. {breakingLine}{breakingLine} You can view the service fees here: ',
  'tiah.landing.FAQ.five.answer.auction.price': 'Auction Price',
  'tiah.landing.FAQ.five.answer.service.fee': 'Service Fee',
  'tiah.landing.FAQ.five.answer.less': 'or less',
  'tiah.landing.FAQ.five.answer.more': 'or more',
  'tiah.landing.FAQ.six.question': 'What if my trade-in is modified?',
  'tiah.landing.FAQ.six.answer':
    'That’s fine. When you inspect your vehicle and send info to the dealer be sure to tell them about any modifications like suspension, exhaust, and body kits. Also, be sure to mention any upgrades like roof racks and winter tires, as in most cases these will bring even more money for your trade-in!',
  'tiah.landing.FAQ.seven.question': 'Can I trade in a classic car?',
  'tiah.landing.FAQ.seven.answer':
    'Yes. While the audience might be niche, there’s often dealers across our nationwide network looking for very specific vehicles including classic cars.',
  'tiah.landing.FAQ.eight.question':
    'What if I don’t know which new vehicle I want yet?',
  'tiah.landing.FAQ.eight.answer':
    'Buying a vehicle can be stressful and scary. Dealers are a great resource to help make an informed choice. But with some dealers you may feel pressure when you talk with them to accept offers. {breakingLine}{breakingLine} You can use TradeRev to start the conversation with a dealer in a low pressure way. They can use TradeRev to get you a great no-committment offer on your trade-in, and knowing how much money you’ll get can help you decide which make or model to go with.',
  'tiah.copyright':
    'Copyright © {year}. TradeRev® is a trademark of NthGen Software®. All rights reserved.',
  'tiah.landing.error.invalid.address':
    'Couldn’t find the location you entered. Try a postal code or city name.',
  'tiah.landing.legal.privacy.policy': 'Privacy policy',
  'tiah.landing.legal.privacy.policy.url':
    'https://www.traderev.com/en-ca/privacy-policy/',
  'tiah.landing.legal.statement': 'Legal statement',

  // TIAH
  'tiah.continue': 'Continue',
  'tiah.nav.help': 'Help',

  // TIAH Mobile Phone Number
  'tiah.phone.title': 'Mobile phone number',
  'tiah.phone.heading': 'Great! Now we’ll confirm your mobile number.',
  'tiah.phone.subheading':
    'We’ll text you a code to enter on the next screen. Then, we’ll use this phone to keep in touch about your trade-in.',
  'tiah.phone.placeholder': 'eg. 905-123-4567',
  'tiah.phone.error':
    'This doesn’t seem to be a valid number. Please check and try again.',

  // TIAH Confirmation Number
  'tiah.confirmation.title': 'CONFIRMATION NUMBER',
  'tiah.confirmation.heading':
    'Enter the confirmation number we just sent you.',
  'tiah.confirmation.label': '4-digit confirmation number',
  'tiah.confirmation.missing': 'Hmm... I didn’t get the code.',
  'tiah.confirmation.error':
    'The number you entered doesn’t match. Please check and try again.',

  // TIAH Dealer Map
  'tiah.map.title': 'DEALER MAP',
  'tiah.map.wrapper.title':
    'Pick the dealer you’d like to buy your next vehicle from.',
  'tiah.map.filter.title': 'FILTER DEALERS',
  'tiah.map.filter.question1': 'Do you have a vehicle to trade in ?',
  'tiah.map.filter.yes': 'Yes',
  'tiah.map.filter.no': 'No',
  'tiah.map.filter.question2': 'Are you looking to buy new or used?',
  'tiah.map.filter.new': 'New',
  'tiah.map.filter.used': 'Used',
  'tiah.map.filter.notsure': 'Not sure',
  'tiah.map.filter.make': 'Make of new vehicle',
  'tiah.map.filter.model': 'Model',
  'tiah.map.filter.help': 'How do I pick the right dealer?',
  'tiah.map.filter.notradein.title':
    'Right now TradeRev is only for trading in.',
  'tiah.map.filter.notradein.message':
    'We’re thrilled you want to try TradeRev! At the moment though, we’re focused on helping people get the best value on their trade-in.',
  'tiah.map.info.valid.traderev': 'Works with traderev',
  'tiah.map.info.button.msg': 'Pick this dealer',
  'tiah.map.modal.close': 'CLOSE',
  'tiah.map.modal.title': ' How do I pick the right dealer to work with?',
  'tiah.map.modal.firstsection':
    'Whichever dealer you pick, when they auction your trade-in with TradeRev you know you’re getting a great value. You don’t need to worry about that.',
  'tiah.map.modal.listheader':
    'Here’s some other things to consider when picking a dealer:',
  'tiah.map.modal.listitem1':
    'Do they sell the make and model of new vehicle you’re looking to buy? Any dealer can take your trade-in, but only certain dealers may have the new car you want.',
  'tiah.map.modal.listitem2':
    'Do they sell only new or used vehicles – or both? Some dealers sell both new and used vehicles, while others only sell used.',
  'tiah.map.modal.lastsection':
    'You can learn a lot about a dealer by visiting their website or calling them quickly.',
  'tiah.map.error.message':
    'There was a problem processing your request. Please try again.',

  // Negotiation modals
  'modal.negotiation.tutorial.title': 'How negotiations work',
  'modal.negotiation.tutorial.negotiation.start': 'Start Negotiation',
  'modal.negotiation.tutorial.buyer.message0':
    'If the <b>seller replies</b>, they will lose the ability to Close this auction. If they do not reply they can close the auction.',
  'modal.negotiation.tutorial.buyer.message1':
    'If the negotiation is successful the vehicle will move to Purchases.',
  'modal.negotiation.tutorial.buyer.message2':
    "If you or the seller <b>declines</b> or the <b>Pending time ends</b>, the seller's lowest negotiated price will be offered as a one time offer to the 2nd place bidder.",
  'modal.negotiation.tutorial.buyer.message3':
    'If you <b>start negotiation</b> and the <b>seller rejects it</b>, the vehicle will go unsold.',
  'modal.negotiation.tutorial.buyer.secondBidder.message0':
    'The seller has unsucessfully tried to negotiate with the top bidder on this vehicle.',
  'modal.negotiation.tutorial.buyer.secondBidder.message1':
    'The seller is willing to sell this vehicle to you for the lowest negotiated price.',
  'modal.negotiation.tutorial.buyer.secondBidder.message2':
    'You can <b>accept or reject</b> this final asking price.',
  'modal.negotiation.tutorial.seller.message0':
    'If the negotiation is successful the vehicle will move to Won or Arrived if in stock.',
  'modal.negotiation.tutorial.seller.message1':
    'If you or the buyer declines in the negotiation, your lowest negotiated price will be offered as a one time offer to the 2nd place bidder.',
  'modal.negotiation.tutorial.seller.message2':
    '<b>If you start or reply to this negotiation you will lose the ability to send this to the Closing Auction.</b>',
  'modal.negotiation.tutorial.seller.open.start.message0':
    'If the negotiation is successful the vehicle will move to Won or Arrived if in stock.',
  'modal.negotiation.tutorial.seller.open.start.message1':
    'If you or the buyer declines in the negotiation this open network trade will be sent to Lost.',
  'modal.negotiation.tutorial.seller.open.start.message2':
    'If this open network negotiation fails, you can still negotiate on the dealer group network version of this trade.',
  'modal.negotiation.tutorial.seller.dgn.firstReply.message0':
    'If you start this negotiation you will lose the ability to send this auction to Closing.',
  'modal.negotiation.tutorial.seller.dgn.firstReply.message1':
    'If the negotiation is successful the vehicle will move to Won or Arrived.',
  'modal.negotiation.tutorial.seller.dgn.message1':
    'If the negotiation is successful the vehicle will move to Won or Arrived if in stock.',
  'modal.negotiation.tutorial.seller.dgn.message2':
    'If you or the buyer declines in the negotiation this dealer group network trade will be sent to Lost.',
  'modal.negotiation.tutorial.seller.dgn.message3':
    'If this dealer group network negotiation fails, you can still negotiate on the open network version of this trade.',
  'modal.negotiation.buyer.floorPriceLabel': 'Floor price: ',
  'modal.negotiation.noOffers': 'No offers yet.',
  'modal.negotiation.negotiationEnded': 'Negotiation has ended.',
  'modal.negotiation.sentToSecondBidder':
    'Final asking price of {price} sent to second bidder',
  'modal.negotiation.offerAmount': 'Offer amount',
  'modal.negotiation.counterAmount': 'Counter amount',
  'modal.negotiation.tip': 'Tip: ',
  'modal.negotiation.seller.tip.part1': 'Consider using your floor price of ',
  'modal.negotiation.seller.tip.part2': ' as a first asking price.',
  'modal.negotiation.buyer.tip.part1': 'Consider using your proxy of ',
  'modal.negotiation.buyer.tip.part2': ' as your first offer.',
  'modal.negotiation.comment': 'Comment',
  'modal.negotiation.optional': 'optional',
  'modal.negotiation.minimumBid': 'Minimum {minimumBid}',
  'modal.negotiation.comment.max': '{value} character max',
  'modal.negotiation.error.noValue': 'Please enter an amount',
  'modal.negotiation.error.lowValue':
    'The offer you entered was too low. Enter an offer at least {minAmount}.',
  'modal.negotiation.error.wrongIncrement':
    'The amount is in the wrong increment. Please use increments of {bidIncrement}',
  'modal.negotiation.comment.placeholder': 'Optional comment',
  'modal.negotiation.send': 'Send',
  'modal.negotiation.loading': 'LOADING',
  'modal.negotiation.newCounter': 'New Counter',
  'modal.negotiation.accept': 'Accept',
  'modal.negotiation.accept.secondBidder': 'Accept {offer}',
  'modal.negotiation.accept.title': 'Accept {offer} offer?',
  'modal.negotiation.accept.description':
    'This will successfully end the negotiations and move this vehicle to Won or Arrived if in-stock.',
  'modal.negotiation.accepted':
    'Negotiation was successful, vehicle moved to {state}.',
  'modal.negotiation.counter.greater.floorPrice.message':
    'The buyer’s last offer for this {name} was {offer}. You can either accept their {offer} offer, or counter with an offer at or below your floor price of {floorPrice}.',
  'modal.negotiation.counter.greater.floorPrice.label':
    'Your counter-offer is above your floor price.',
  'modal.negotiation.accept.toHigh.message':
    'The seller’s last offer for this {name} was {offer}. You can either accept {offer}, or counter with a lower offer amount.',
  'modal.negotiation.accept.toHigh.label':
    'Your counter-offer is higher than the seller’s last offer.',
  'modal.negotiation.accept.toLow.message':
    'The buyer’s last offer for this {name} was {offer}. You can either accept their {offer} offer, or counter with a higher offer amount.',
  'modal.negotiation.accept.toLow.label':
    'Your counter-offer is below the buyer’s last offer',
  'modal.negotiation.accept.error': 'Something went wrong',
  'modal.negotiation.dismiss': 'Dismiss',
  'modal.negotiation.counter': 'Counter',
  'modal.negotiation.stayFirm': 'Stay firm',
  'modal.negotiation.stayFirm.stayFirmButton': 'stay firm at {offer}',
  'modal.negotiation.stayFirm.stayFirmLabel': 'Firm at {offer}',
  'modal.negotiation.decline.seller.title': 'Decline buyer’s first offer',
  'modal.negotiation.decline.seller.description.msg1':
    'You can decline the offer and send this vehicle to Closing to continue the auction with the top two bidders.',
  'modal.negotiation.decline.seller.description.msg2':
    'If you do not want to continue the auction, send the vehicle to Lost.',
  'modal.negotiation.decline.seller.sendToClosing': 'Send to closing',
  'modal.negotiation.decline.seller.sendToLost': 'Send to lost',
  'modal.negotiation.decline': 'Decline',
  'modal.negotiation.decline.success': 'Negotiation declined.',
  'modal.negotiation.decline.secondBidder.success':
    'Negotiation declined, final asking price sent to 2nd place bidder.',
  'modal.negotiation.buyer.decline.title': 'Decline {offer} asking price?',
  'modal.negotiation.buyer.decline.description':
    "Declining will end this auction. The seller's lowest asking price will now be offered to the second highest bidder.",
  'modal.negotiation.seller.decline.title': 'End negotiation?',
  'modal.negotiation.seller.decline.description':
    'This will end this negotiation. A final ask of {askingPrice} will be made to the 2nd place bidder. If they do not accept, or if there is no 2nd place bidder it will be sent to Lost.',
  'modal.negotiation.decline.description.secondBidder':
    'This will end this auction.',
  'modal.negotiation.decline.dgn.description':
    'Declining will end this auction.',
  'modal.negotiation.buyer.decline.yesDecline': 'Yes, decline',
  'modal.negotiation.seller.decline.yesDecline': 'End negotiation',
  'modal.negotiation.lastBid': 'Last bid',
  'modal.negotiation.floorPrice': 'Floor Price',
  'modal.negotiation.proxyAmount': 'Your proxy in auction',
  'modal.negotiation.offer.today': "'Today at' h':'mm aaa",
  'modal.negotiation.offer.yesterday': "'Yesterday at' h':'mm aaa",
  'modal.negotiation.offer.someDay': "MMM do 'at' h':'mm aaa",
  'modal.negotiation.highBid.message':
    'Your offer of {amount} seems like it might be high. Did you mean to enter an offer of {amount}? If so, you can continue below.',
  'modal.decision.sendToClosing.title': 'Send vehicle to Closing auction',
  'modal.decision.sendToClosing.message.dgnTrade':
    'The top two bidders will continue to bid until there is a winner. The Open network version of this trade will be sent to Lost.',
  'modal.decision.sendToClosing.message.openTrade':
    'The top two bidders will continue to bid until there is a winner. The dealer group network version of this trade will be sent to Lost.',
  'modal.decision.sendToClosing.message0':
    'The top two bidders will continue to bid in the Closing auction until there is a winner. The final bid in auction will be the final sale price.',
  'modal.decision.sendToClosing.button.sendToClosing':
    'Send to Closing auction',
  'modal.decision.sendToClosing.message1':
    'The Active auction ended at <b>{topBid}</b>.{linebreak}What is the <b>actual cash value</b>?',
  'modal.decision.sendToClosing.success': 'Vehicle has been sent to Closing.',
  'modal.decision.sendToClosing.error':
    'Failed to move vehicle to Closing. Try again later.',
  'negotiation.free.disclaimer':
    'Negotiating is free. Get a deal done by starting a negotiation.',
  'negotiation.tip.offer.proxy': 'A deal might be close!{br}Offer your proxy.',
  'negotiation.encourage.modal.heading':
    'Are you sure you want to {actionLabel}?',
  'negotiation.encourage.modal.message':
    'The auction ended without a deal, but the buyer might be willing to offer more money.{br}We suggest starting a negotiation with the highest bidder.',
  'negotiation.send.to.lost': 'Send to Lost',
  'negotiation.send.to.closing': 'Send to Closing',
  'negotiation.send.to.parked': 'Send to Parked',
  'auto.win.on.disclaimer':
    'Auto-win is on: We’ll use your proxy amount to try and win if the floor price isn’t met or during a negotiation.',
  'your.proxy': 'Your proxy',
  'okta.redirect.loading': 'Loading...',
  // Payments on Hold
  'paymentsOnHold.totalAmountOnHold': 'Total amount on hold:',
  'paymentsOnHold.ownershipsOwing': 'Ownerships owing:',
  'paymentsOnHold.lienReleasesOwing': 'Lien releases owing:',
  'paymentsOnHold.sort.oldestFirst': 'Oldest first',
  'paymentsOnHold.sort.newestFirst': 'Newest first',
  'paymentsOnHold.sort.highestPriceFirst': 'Highest price first',
  'paymentsOnHold.owing': 'Owing',
  'paymentsOnHold.processing': 'Processing',
  'paymentsOnHold.approvedPrintLabel': 'Approved (print label)',
  'paymentsOnHold.upload': 'Upload again',
  'paymentsOnHold.readyForPickup': 'Ready for pickup',
  'paymentsOnHold.pickedUp': 'Picked up',
  'paymentsOnHold.verified': 'Verified',
  'paymentsOnHold.lienRelease': 'Lien release letter',
  'paymentsOnHold.lienRelease.neededForFunding':
    'Lien release letter needed for funding',
  'paymentsOnHold.ownership': 'Ownership',
  'paymentsOnHold.ownership.neededForFunding': 'Ownership needed for funding',
  'paymentsOnHold.emailTo': 'Email to',
  'paymentsOnHold.sendTo': 'Send to:',
  'paymentsOnHold.documentsOwing': 'Documents owing',
  'paymentsOnHold.soldFor': 'Sold For',
  'paymentsOnHold.uploadDocument.uploadOwnership': 'Upload ownership',
  'paymentsOnHold.uploadDocument.uploadLienRelease': 'Upload lien release',
  'paymentsOnHold.uploadDocument.uploadOwnershipForVin':
    'Upload ownership for {vin}',
  'paymentsOnHold.uploadDocument.uploadLienReleaseForVin':
    'Upload lien release for {vin}',
  'paymentsOnHold.uploadDocument.uploadedOwnerships':
    'Uploaded ownership documents',
  'paymentsOnHold.uploadDocument.uploadedLienReleases':
    'Uploaded lien release documents',
  'paymentsOnHold.uploadDocument.viewOwnership': 'View ownership',
  'paymentsOnHold.uploadDocument.viewLienRelease': 'View lien release',
  'paymentsOnHold.uploadDocument.reviewOwnership': 'Review ownership',
  'paymentsOnHold.uploadDocument.reviewLienRelease': 'Review lien release',
  'paymentsOnHold.uploadDocument.empty': 'Empty',
  'paymentsOnHold.uploadDocument.failed':
    'Upload failed. Please make sure the file type and size are correct and try again',
  'paymentsOnHold.submitDocument.success': 'Successfully submitted documents',
  'paymentsOnHold.submitDocument.failed':
    'Failed to submit documents. Please try again later.',
  'paymentsOnHold.deleteDocument.success': 'Successfully deleted document',
  'paymentsOnHold.deleteDocument.failed': 'Failed to delete document',
  'paymentsOnHold.deleteDocument.modal.title':
    'Are you sure you want to remove this file?',
  'paymentsOnHold.deleteDocument.modal.message':
    'You will not be able to receive funds for this vehicle without the required documents.',
  'paymentsOnHold.greatNews': 'Great news!',
  'paymentsOnHold.placeholderMessage':
    "Looks like you don't have any vehicles with payments on hold.",
  'paymentsOnHold.uploadDocument.lien.allowedFileTypes': 'PDF, JPG, PNG only.',
  'paymentsOnHold.uploadDocument.title.allowedFileTypes': 'PDF only.',
  'paymentsOnHold.uploadDocument.maxFileSize': 'Max. File size: 10MB',
  'paymentsOnHold.uploadDocument.ownership.info':
    "Important notes before uploading ownership documentation:{br}1.) When the buyer is not a Quebec dealer, an unsigned vehicle registration must be in the selling dealer's name. (You must have Power of Attorney on record with TradeRev).{br}2.) When the buyer is a Quebec dealer - vehicle registration must be in the buying dealers name.",
  'paymentsOnHold.uploadDocument.dragAndDrop':
    'You can drag and drop multiple files here or',
  'paymentsOnHold.uploadDocument.browse': 'browse',

  // TradeStates
  'tradeState.active': 'Active',
  'tradeState.upcoming': 'Upcoming',
  'tradeState.pending': 'Pending',
  'tradeState.closing': 'Closing',
  'tradeState.purchase': 'Purchases',
  'tradeState.won': 'Won',
  'tradeState.arrived': 'Arrived',
  'tradeState.delivered': 'Delivered',
  'tradeState.lost': 'Lost',
  'tradeState.parked': 'Parked',
  'tradeState.consigned': 'Simulcast',
  'tradeState.won.omp': 'Sold',
  'tradeState.arrived.omp': 'Landed',
  'tradeState.delivered.omp': 'Picked up',
  'tradeState.lost.omp': 'Not sold',
  'tradeState.parked.omp': 'Parked',
  'tradeState.active.omp': 'Active',
  'tradeState.upcoming.omp': 'Upcoming',
  'tradeState.pending.omp': 'Pending',
  'tradeState.closing.omp': 'Closing',
  'tradeState.purchase.omp': 'Purchases',
  'tradeState.consigned.omp': 'Simulcast',

  // Auto Win Setting
  'autowin.setting.bid.settings': 'BID SETTINGS',
  'autowin.setting.auto.win': 'Auto-Win',
  'autowin.setting.description':
    'Auto-Win will submit a bid on your behalf to help you win vehicles in certain situations where you’re top bidder.',
  'autowin.setting.unmet.floor.price.ends':
    'If an auction with an un-met floor price ends;',
  'autowin.setting.proxy.bid':
    'And you’re high bidder with a proxy bid above the seller’s floor price you will automatically win the vehicle for the floor price amount.',
  'autowin.setting.negotiation': 'If an auction goes into negotiation;',
  'autowin.setting.seller.first.offer':
    'And your proxy is higher than the seller’s first offer you will automatically win the vehicle for the seller’s first offer amount.',
  'autowin.setting.enable.auto.win': 'Enable Auto-Win',
  'autowin.setting.save': 'Save',
  'autowin.setting.enabled': "You've now enabled Auto-Win!",
  'autowin.setting.disabled': "You've now disabled Auto-Win!",
  'autowin.setting.unmet.floor.price.ends.rebrand':
    'If an auction where you’re top bidder ends with an un-met floor price, and your proxy bid is higher than the seller’s floor price, you will automatically win the vehicle for the seller’s floor price amount.',
  'autowin.setting.seller.first.offer.rebrand':
    'If an auction you’re top bidder on goes into negotiation and your proxy bid is higher than the seller’s first offer, you will automatically win the vehicle for the seller’s first offer amount.',
  'autowin.settings.how.it.works': "Here's how it works:",
  'autowin.setting.or': 'OR',

  // Retail Tools Setting
  'retail.tools.setting': 'Retail Tools',
  'retail.tools.setting.description':
    'Personalize content your retail customers will see.',
  'retail.tools.setting.heading': 'Dealership info',
  'retail.tools.setting.heading.description':
    'Updating these settings will also change the appearance for all previously generated links from this dealership.',
  'retail.tools.setting.upload.logo': 'Upload Logo',
  'retail.tools.setting.upload.logo.for': 'Upload logo for',
  'retail.tools.setting.edit.logo': 'Edit Logo',
  'retail.tools.setting.edit.logo.for': 'Edit logo for',
  'retail.tools.setting.upload.logo.description':
    'The dealership logo will appear to your customers on the inspection landing page.',
  'retail.tools.setting.logo.note':
    '<b>NOTE:</b> Images will accept .PNG and .JPEG. Transparent background preferred.',
  'retail.tools.setting.logo.size':
    'Images must be a minimum of 500 x 500 pixels and less than 15MB',
  'retail.tools.setting.tiah.heading': 'Retail inspect landing page',
  'retail.tools.setting.tiah.heading.for': 'Retail inspect landing page for',
  'retail.tools.setting.tiah.description':
    'This is the page that customers first see when they open the customer invite link sent by your dealership. This is found under Selling / Create.',
  'retail.tools.setting.retailVdp.heading': 'Retail condition report info',
  'retail.tools.setting.retailVdp.heading.for':
    'Retail condition report info for',
  'retail.tools.setting.retailVdp.description':
    'This information will be pre-populated when you share a vehicle from the condition report. You can also change it if you wish at that time.',
  'retail.tools.setting.retailVdp.inventory.disclaimer':
    'If the customer is not interested in the vehicle you’re sharing, we will show a link to your other used inventory',
  'retail.tools.setting.warning': 'WARNING',
  'retail.tools.setting.warning.message':
    'Updating this template settings will also change the appearance and settings for all previously generated links from this account.',
  'retail.tools.setting.logo.upload.error':
    "The image you tried to upload doesn't meet the requirements.Try again.",
  'retail.tools.setting.confirmation':
    'Your configurations have been saved. The updates are now live on your retail tools!'
};
